import useRestQuery from "@/remoteState/useRestQuery";

export const PARNASSUS_HOST =
  process.env.NEXT_PUBLIC_PARNASSUS_URL || "/parnassus/api/v2";
const useArticleGetByContentId = (contentId) => {
  const contentUrl = `${PARNASSUS_HOST}/articles/content/${contentId}/`;
  return useRestQuery(contentUrl);
};

export default useArticleGetByContentId;
